module.exports = __webpack_public_path__ + "img/Icon-arrow.080220b5.svg";